// extracted by mini-css-extract-plugin
module.exports = {"wheelList":"wheelList__SLVxcJlbEv-Kv","emptyWheel":"emptyWheel__PhgzARJx9syNW","footer":"footer__EylClGvEVjFx1"};